/**
 * The API serialises naive UTC timestamps ("2026-08-13T19:11:51.476005"): no offset,
 * no trailing "Z". `new Date()` reads those as *local* time, which silently shifts every
 * timestamp by the visitor's offset — and west of UTC that made freshly bought
 * activations look hours old, so the poller decided nothing was pending and no code ever
 * appeared on screen. Always parse server timestamps through here.
 */
export function parseServerDate(value: string | null | undefined): number {
  if (!value) return NaN;
  const hasZone = /(?:Z|[+-]\d{2}:?\d{2})$/.test(value);
  return new Date(hasZone ? value : `${value}Z`).getTime();
}

const pad = (n: number) => String(n).padStart(2, "0");

/**
 * A server timestamp as `DD/MM/YYYY HH:mm` in the viewer's own local time. The format is
 * fixed on purpose (the owner asked for day-first, whatever the UI language); the
 * timezone is always the browser's. Returns "—" for a missing or unparseable value.
 */
export function formatServerDateTime(value: string | null | undefined): string {
  const ms = parseServerDate(value);
  if (Number.isNaN(ms)) return "—";
  const d = new Date(ms);
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
